import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Global 401 handler — when running as an installed PWA on iOS/Android, the
// auth cookie can be silently dropped when the OS reclaims memory. Surface it
// instead of letting every request silently fail. We dispatch a custom event
// so AuthContext can clear `user` and the router can bounce to /login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try {
        const ev = new CustomEvent('majnu:auth-expired');
        window.dispatchEvent(ev);
      } catch { /* ignore */ }
    }
    return Promise.reject(error);
  }
);

export default api;
